import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import './Pricing.css';

function Pricing() {
  const { t } = useLanguage();

  const pricingPlans = [
    {
      id: 1,
      name: t('pricing.plans.monthly.name'),
      price: '₹2,000',
      period: t('pricing.plans.monthly.period'),
      description: t('pricing.plans.monthly.desc'),
      features: [
        t('pricing.plans.features.unlimited'),
        t('pricing.plans.features.all_levels'),
        t('pricing.plans.features.online_offline'),
        t('pricing.plans.features.community'),
        t('pricing.plans.features.basic_support')
      ],
      popular: false
    },
    {
      id: 2,
      name: t('pricing.plans.quarterly.name'),
      price: '₹5,400',
      period: t('pricing.plans.quarterly.period'),
      description: t('pricing.plans.quarterly.desc'),
      features: [
        t('pricing.plans.features.unlimited'),
        t('pricing.plans.features.all_levels'),
        t('pricing.plans.features.online_offline'),
        t('pricing.plans.features.community'),
        t('pricing.plans.features.priority_support'),
        t('pricing.plans.features.free_session_1')
      ],
      popular: true,
      discount: t('pricing.plans.quarterly.discount')
    },
    {
      id: 3,
      name: t('pricing.plans.half_yearly.name'),
      price: '₹10,800',
      period: t('pricing.plans.half_yearly.period'),
      description: t('pricing.plans.half_yearly.desc'),
      features: [
        t('pricing.plans.features.unlimited'),
        t('pricing.plans.features.all_levels'),
        t('pricing.plans.features.online_offline'),
        t('pricing.plans.features.community'),
        t('pricing.plans.features.premium_support'),
        t('pricing.plans.features.free_session_2'),
        t('pricing.plans.features.workshops')
      ],
      popular: false,
      discount: t('pricing.plans.half_yearly.discount')
    }
  ];

  const additionalServices = [
    {
      id: 1,
      name: t('pricing.services.online.name'),
      price: '₹500',
      description: t('pricing.services.online.desc')
    },
    {
      id: 2,
      name: t('pricing.services.workshop.name'),
      price: '₹1,500',
      description: t('pricing.services.workshop.desc')
    },
    {
      id: 3,
      name: t('pricing.services.private.name'),
      price: '₹1,000',
      description: t('pricing.services.private.desc')
    },
    {
      id: 4,
      name: t('pricing.services.corporate.name'),
      price: t('pricing.services.corporate.price'),
      description: t('pricing.services.corporate.desc')
    }
  ];

  return (
    <div className="pricing">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>{t('pricing.header.title')}</h1>
          <p>{t('pricing.header.subtitle')}</p>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="pricing-cards-section">
        <div className="container">
          <div className="pricing-grid">
            {pricingPlans.map((plan) => (
              <div key={plan.id} className={`pricing-card ${plan.popular ? 'popular' : ''}`}>
                {plan.discount && (
                  <div className="discount-badge">{plan.discount}</div>
                )}
                <h3 className="plan-name">{plan.name}</h3>
                <p className="plan-description">{plan.description}</p>

                <div className="price-section">
                  <span className="price">{plan.price}</span>
                  <span className="period">{plan.period}</span>
                </div>

                <ul className="features-list">
                  {plan.features.map((feature, index) => (
                    <li key={index}>
                      <span className="checkmark">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link to="/booking" className="plan-btn">
                  {t('pricing.plans.join_btn')}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="additional-services">
        <div className="container">
          <h2 className="section-title">{t('pricing.services.title')}</h2>
          <p className="section-subtitle">{t('pricing.services.subtitle')}</p>

          <div className="services-grid">
            {additionalServices.map((service) => (
              <div key={service.id} className="service-card">
                <h4>{service.name}</h4>
                <p className="service-price">{service.price}</p>
                <p className="service-description">{service.description}</p>
                <button className="service-btn">{t('pricing.services.learn_btn')}</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-title">{t('pricing.faq.title')}</h2>

          <div className="faq-grid">
            <div className="faq-item">
              <h4>{t('pricing.faq.q1')}</h4>
              <p>{t('pricing.faq.a1')}</p>
            </div>
            <div className="faq-item">
              <h4>{t('pricing.faq.q2')}</h4>
              <p>{t('pricing.faq.a2')}</p>
            </div>
            <div className="faq-item">
              <h4>{t('pricing.faq.q3')}</h4>
              <p>{t('pricing.faq.a3')}</p>
            </div>
            <div className="faq-item">
              <h4>{t('pricing.faq.q4')}</h4>
              <p>{t('pricing.faq.a4')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>{t('pricing.cta.title')}</h2>
          <p>{t('pricing.cta.desc')}</p>
          <Link to="/booking" className="btn btn-primary btn-large">
            {t('pricing.cta.btn')}
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Pricing;
